import React from 'react';
import {ChakraProvider, theme,Text, Flex, Image, Box, Link} from "@chakra-ui/react";
import ArrowIcon from '../assets/img/arrow_back.svg';
import { useHistory } from 'react-router';

const LoginTitleCard = (props) =>{
  const history = useHistory();
  
    return(
      <ChakraProvider theme={theme}>
        <Link onClick={() => history.goBack()}>
        <Flex alignItems="center" justifyContent="space-between">
        <Box pt="6" pb="4" pl="4">
        <Image 
          src={ArrowIcon}
          alt="Arrow Icon"
          w="20px"
          h="20px"
          />
        </Box>
        </Flex>
        </Link>

        <Flex
        flexDirection="column"
        pt="6"
        pl="5"
        pr="4">
        <Text
        color="#222222"
        fontWeight="700"
        fontSize="24px">
          {props.CardTitle}
        </Text>
        <Text
        pt="4"
        pl="0"
        pr="4"
        color="#666666"
        fontWeight="400"
        fontSize="15px">
          {props.CardInfo}
        </Text>
        </Flex>
    </ChakraProvider>
)}

export default LoginTitleCard;